import React from 'react';
import { useParams, useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import StaffLayout from '../../components/StaffLayout';
import Receipt from '../../components/Receipt';
import { useApi } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { journalPreferences } from '../../lib/journalNavigation';

export default function ReceiptDetailPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { data: tx, loading, error } = useApi(`/transactions/${id}`);

  if (loading) return <StaffLayout><div data-testid="receipt-loading" className="text-center py-20 text-slate-500">Loading receipt…</div></StaffLayout>;
  if (error || !tx) return <StaffLayout><div data-testid="receipt-load-error" className="text-center py-20 text-slate-500">Transaction not found</div></StaffLayout>;

  const newTxTo = tx.type.startsWith('loan') ? '/app/loans' : '/app/journal';
  const preferences = journalPreferences(location.state?.journalPreferences || tx);
  const newTransaction = () => navigate(newTxTo, { replace: true, state: { journalPreferences: preferences } });
  const back = () => {
    if (window.history.state?.idx > 0) navigate(-1);
    else newTransaction();
  };

  return (
    <StaffLayout>
      <Receipt tx={tx} customer={tx.customer} shopName={user?.shopName} autoPrint={params.get('print') === '1'} newTxTo={newTxTo} onBack={back} onNewTransaction={newTransaction} />
    </StaffLayout>
  );
}
